// Reduxのアクションタイプをまとめたファイル。

// type を指定しないことを敢えて明示したい場合に使用
export const DEFAULT = 'DEFAULT';

// ログイン
export const SUCCESS_API_LOGIN = 'SUCCESS_API_LOGIN';
export const FAILURE_API_LOGIN = 'FAILURE_API_LOGIN';

// ログアウト
export const LOGOUT = 'LOGOUT';
export const LOGOUT_DONE = 'LOGOUT_DONE';
// export const SUCCESS_API_LOGOUT = 'SUCCESS_API_LOGOUT';

// デバイス認証
export const SUCCESS_API_CONFIRM_DEVICE_AUTH =
  'SUCCESS_API_CONFIRM_DEVICE_AUTH';
export const SUCCESS_API_CHECK_DEVICE_AUTH_CODE =
  'SUCCESS_API_CHECK_DEVICE_AUTH_CODE';
export const ERROR_API_CHECK_DEVICE_AUTH_CODE =
  'ERROR_API_CHECK_DEVICE_AUTH_CODE';
export const RESET_DEVICE_AUTH_ERROR = 'RESET_DEVICE_AUTH_ERROR';
export const SUCCESS_API_GET_ACCESS_CONTROL_OPERATORS =
  'SUCCESS_API_GET_ACCESS_CONTROL_OPERATORS'; // メール送信先の選択肢としてユーザー一覧を取得
export const SUCCESS_API_GET_DEVICE_AUTH_SETTINGS =
  'SUCCESS_API_GET_DEVICE_AUTH_SETTINGS';
export const SUCCESS_API_GET_DEVICE_AUTH_SUBSCRIPTION_SETTINGS =
  'SUCCESS_API_GET_DEVICE_AUTH_SUBSCRIPTION_SETTINGS';

// プルダウンメニュー
export const CLOSE_MENU = 'CLOSE_MENU';
export const TOGGLE_MENU = 'TOGGLE_MENU';

// UserPrompt
export const OPEN_USER_PROMPT = 'OPEN_USER_PROMPT';
export const CLOSE_USER_PROMPT = 'CLOSE_USER_PROMPT';

// 記録データ一覧取得
export const SUCCESS_API_GET_WORK_RECORD = 'SUCCESS_API_GET_WORK_RECORD';

// 記録データ一覧取得
export const SUCCESS_API_GET_WORK_RECORDS = 'SUCCESS_API_GET_WORK_RECORDS';

// 記録データ情報消去
export const RESET_WORK_RECORD = 'RESET_WORK_RECORD';

// 記録データステータス更新
export const SUCCESS_API_UPDATE_WORK_RECORD_STATUS =
  'SUCCESS_API_UPDATE_WORK_RECORD_STATUS';

// 記録データ削除
export const SUCCESS_API_DELETE_WORK_RECORDS =
  'SUCCESS_API_DELETE_WORK_RECORDS';

// ページネーションのページ選択
export const PAGENATION_SELECT_PAGE = 'PAGENATION_SELECT_PAGE';

// ユーザ情報取得
export const SUCCESS_API_GET_USER_INFO = 'SUCCESS_API_GET_USER_INFO';
export const RESET_OPERATOR_INFO = 'RESET_OPERATOR_INFO';

export const SUCCESS_API_GET_OPERATORS = 'SUCCESS_API_GET_OPERATORS';
export const RESET_OPERATORS_INFO = 'RESET_OPERATORS_INFO';

// タイムラインソート項目変更
export const TIMELINELISTS_CHANGE_SORT = 'TIMELINELISTS_CHANGE_SORT';

// 検索オプションの更新
export const SEARCHBOX_UPDATE_SEARCH_OPTIONS =
  'SEARCHBOX_UPDATE_SEARCH_OPTIONS';
export const SEARCHBOX_RESET_SEARCH_OPTIONS = 'SEARCHBOX_RESET_SEARCH_OPTIONS';

// ダウンロード開始(一括ダウンロードボタンが押されてAPIリクエストをした)
export const REQUEST_API_DOWNLOAD_MEDIA_FILES =
  'REQUEST_API_DOWNLOAD_MEDIA_FILES';

// ダウンロード成功(ZIPファイルのダウンロードが始まった)
export const SUCCESS_API_DOWNLOAD_MEDIA_FILES =
  'SUCCESS_API_DOWNLOAD_MEDIA_FILES';

// QRコード情報操作
export const CREATE_QRCODE = 'CREATE_QRCODE';
export const UPDATE_QRCODE_EXPIRE_DATE = 'UPDATE_QRCODE_EXPIRE_DATE';

export const SUCCESS_API_GET_QR = 'SUCCESS_API_GET_QR';
export const SUCCESS_API_LIST_QRS = 'SUCCESS_API_LIST_QRS';
export const SUCCESS_API_UPDATE_QR = 'SUCCESS_API_UPDATE_QR';

// タイルモード
export const OPEN_TILE_TIMELINE = 'OPEN_TILE_TIMELINE';
export const CLOSE_TILE_TIMELINE = 'CLOSE_TILE_TIMELINE';

export const SUCCESS_API_ANALYZE = 'SUCCESS_API_ANALYZE';
export const ERROR_API_ANALYZE = 'ERROR_API_ANALYZE';

// ユーザ情報表示
export const OPEN_USER_INFO_DIALOG = 'OPEN_USER_INFO_DIALOG';
export const CLOSE_USER_INFO_DIALOG = 'CLOSE_USER_INFO_DIALOG';

// ユーザ情報更新
export const SUCCESS_API_UPDATE_OPERATORS = 'SUCCESS_API_UPDATE_OPERATORS';
export const SUCCESS_API_CREATE_OPERATOR = 'SUCCESS_API_CREATE_OPERATOR';
export const UPDATE_ROLE_SELECT = 'UPDATE_ROLE_SELECT';
export const OPEN_UPDATE_STAFF_DIALOG = 'OPEN_UPDATE_STAFF_DIALOG';
export const CLOSE_UPDATE_STAFF_DIALOG = 'CLOSE_UPDATE_STAFF_DIALOG';
export const ERROR_API_UPDATE_OPERATORS_STATUS =
  'ERROR_API_UPDATE_OPERATORS_STATUS';
export const RESET_STAFF_CONFIRM_DATA = 'RESET_STAFF_CONFIRM_DATA';

// 企業情報取得更新
export const SUCCESS_API_GET_COMPANIES = 'SUCCESS_API_GET_COMPANIES';
export const SUCCESS_API_UPDATE_COMPANIES = 'SUCCESS_API_UPDATE_COMPANIES';
export const SUCCESS_API_CREATE_COMPANY = 'SUCCESS_API_CREATE_COMPANY';
export const ERROR_API_CREATE_COMPANY = 'ERROR_API_CREATE_COMPANY';

export const UPDATE_CONFIRM_DATA = 'UPDATE_CONFIRM_DATA';
export const OPEN_UPDATE_COMPANY_DIALOG = 'OPEN_UPDATE_COMPANY_DIALOG';
export const CLOSE_UPDATE_COMPANY_DIALOG = 'CLOSE_UPDATE_COMPANY_DIALOG';
export const OPEN_CREATE_COMPANY_DIALOG = 'OPEN_CREATE_COMPANY_DIALOG';
export const CLOSE_CREATE_COMPANY_DIALOG = 'CLOSE_CREATE_COMPANY_DIALOG';
export const SET_GEOCODE_UPDATE_COMPANY_DIALOG =
  'SET_GEOCODE_UPDATE_COMPANY_DIALOG';
export const UPDATE_COMPANY_SEARCH_OPTIONS = 'UPDATE_COMPANY_SEARCH_OPTIONS';
export const RESET_COMPANY_SEARCH_OPTIONS = 'RESET_COMPANY_SEARCH_OPTIONS';

// 企業絞り込み
export const SELECT_COMPANY = 'SELECT_COMPANY';

// 権限絞り込み
export const SELECT_ROLE = 'SELECT_ROLE';

// 状態絞り込み
export const SELECT_ACCOUNT_STATUS = 'SELECT_ACCOUNT_STATUS';

// 作業者名絞り込み
export const SEARCH_USER_NAME = 'SEARCH_USER_NAME';

// タイムラインチェックボックス
export const TIMELINELISTS_CHECKBOX_CHECK = 'TIMELINELISTS_CHECKBOX_CHECK';

// 位置情報取得
export const OPEN_LOCATION_SEARCH = 'OPEN_LOCATION_SEARCH';
export const CLOSE_LOCATION_SEARCH = 'CLOSE_LOCATION_SEARCH';
export const CHANGE_POINT_LOCATION_SEARCH = 'CHANGE_POINT_LOCATION_SEARCH';
export const INPUT_SEARCH_LOCATION_SEARCH = 'INPUT_SEARCH_LOCATION_SEARCH';
export const SUCCESS_API_GET_GEOCODE = 'SUCCESS_API_GET_GEOCODE';

// バックエンドversion
export const SUCCESS_API_APP_RELEASE_NUMBER = 'SUCCESS_API_APP_RELEASE_NUMBER';

// 企業管理タブ選択
export const UPDATE_COMPANY_SELECT_TAB = 'UPDATE_COMPANY_SELECT_TAB';

// ストレージプラン選択
export const SELECT_STORAGE_PLAN = 'SELECT_STORAGE_PLAN';

// 遠隔作業支援選択
export const SELECT_REMOTE_SUPPORT_STATUS = 'SELECT_REMOTE_SUPPORT_STATUS';

// ライセンス更新
export const UPDATE_LICENSE = 'UPDATE_LICENSE';

// ライセンス超過企業抽出
export const CHECKED_LICENSE_OVER = 'CHECKED_LICENSE_OVER';

// デバイス管理
export const API_GET_DEVICES = 'API_GET_DEVICES';
export const SUCCESS_API_GET_DEVICES = 'SUCCESS_API_GET_DEVICES';
export const API_GET_DEVICE_DETAIL = 'API_GET_DEVICE_DETAIL';
export const SUCCESS_API_GET_DEVICE_DETAIL = 'SUCCESS_API_GET_DEVICE_DETAIL';
export const API_UPDATE_DEVICE = 'API_UPDATE_DEVICE';
export const SUCCESS_API_UPDATE_DEVICE = 'SUCCESS_API_UPDATE_DEVICE';

// 遠隔作業支援
export const SUCCESS_API_CREATE_ROOM = 'SUCCESS_API_CREATE_ROOM';
export const SUCCESS_API_GET_NO_JOINED_ROOMS =
  'SUCCESS_API_GET_NO_JOINED_ROOMS';
export const SUCCESS_API_GET_ENTER_ROOM_INFO =
  'SUCCESS_API_GET_ENTER_ROOM_INFO';
export const SUCCESS_API_GET_ROOM_INFO = 'SUCCESS_API_GET_ROOM_INFO';
export const SUCCESS_API_GET_CALLING_ROOM_MEMBERS =
  'SUCCESS_API_GET_CALLING_ROOM_MEMBERS';
export const SUCCESS_API_UPDATE_USER_DEVICE_INFO =
  'SUCCESS_API_UPDATE_USER_DEVICE_INFO';
export const SUCCESS_API_UPDATE_MEMBER_STATUS =
  'SUCCESS_API_UPDATE_MEMBER_STATUS';
export const REMOTE_SUPPORT_READY = 'REMOTE_SUPPORT_READY';
export const SET_REMOTE_ENABLED = 'SET_REMOTE_ENABLED';
export const ENTER_ROOM = 'ENTER_ROOM';
export const LEAVE_ROOM = 'LEAVE_ROOM';
export const INIT_ROOM_ERROR_CODE = 'INIT_ROOM_ERROR_CODE';
export const SET_STEP = 'SET_STEP';
export const SUCCESS_API_DELETE_ROOM = 'SUCCESS_API_DELETE_ROOM';
export const RECEIVED_ROOM_INCOMING_INFO = 'RECEIVED_ROOM_INCOMING_INFO';
export const RECEIVED_ROOM_OUTGOING_INFO = 'RECEIVED_ROOM_OUTGOING_INFO';
export const SUCCESS_API_RECALL_ROOM_MEMBER = 'SUCCESS_API_RECALL_ROOM_MEMBER';
export const SUCCESS_API_GET_HISTORIES = 'SUCCESS_API_GET_HISTORIES';

// ユーザにひもづくデバイス一覧取得
export const SUCCESS_API_GET_USER_DEVICES = 'SUCCESS_API_GET_USER_DEVICES';

// Tag情報
export const SUCCESS_API_GET_TAGS = 'SUCCESS_API_GET_TAGS';
export const SUCCESS_API_GET_COMPANY_TAG_SET =
  'SUCCESS_API_GET_COMPANY_TAG_SET';
export const SUCCESS_API_GET_COMPANY_TAGS = 'SUCCESS_API_GET_COMPANY_TAGS';
export const SUCCESS_API_GET_MULTI_LEVEL_TAGS =
  'SUCCESS_API_GET_MULTI_LEVEL_TAGS';
export const SUCCESS_API_IMPORT_TAGS = 'SUCCESS_API_IMPORT_TAGS';
export const SUCCESS_API_REIMPORT_TAGS = 'SUCCESS_API_REIMPORT_TAGS';
export const SELECT_IMPORT_CSV = 'SELECT_IMPORT_CSV';
export const SUCCESS_UPDATE_WROKRECORD_TAG = 'SUCCESS_UPDATE_WROKRECORD_TAG';
export const SET_TAGS_FOR_LEVEL = 'SET_TAGS_FOR_LEVEL';

// タグマスタ
export const SUCCESS_UPDATE_TAGS = 'SUCCESS_UPDATE_TAGS';
export const SUCCESS_DELETE_TAGS = 'SUCCESS_DELETE_TAGS';
export const OPEN_EDIT_MASTER_DIALOG = 'OPEN_EDIT_MASTER_DIALOG';
export const CLOSE_EDIT_MASTER_DIALOG = 'CLOSE_EDIT_MASTER_DIALOG';
export const OPEN_ONE_LAYER_MASTER_IMPORT_DIALOG =
  'OPEN_ONE_LAYER_MASTER_IMPORT_DIALOG';
export const CLOSE_ONE_LAYER_MASTER_IMPORT_DIALOG =
  'CLOSE_ONE_LAYER_MASTER_IMPORT_DIALOG';
export const OPEN_MASTER_IMPORT_DIALOG = 'OPEN_MASTER_IMPORT_DIALOG';
export const CLOSE_MASTER_IMPORT_DIALOG = 'CLOSE_MASTER_IMPORT_DIALOG';
export const OPEN_IMPORT_ERROR_DIALOG = 'OPEN_IMPORT_ERROR_DIALOG';
export const CLOSE_IMPORT_ERROR_DIALOG = 'CLOSE_IMPORT_ERROR_DIALOG';
export const SET_SELECTED_TAG_SET = 'SET_SELECTED_TAG_SET';
export const SET_SELECTED_TAG = 'SET_SELECTED_TAG';
export const SWITCH_SHOW_EDIT_MASTER_DIALOG_ERROR_MSG =
  'SWITCH_SHOW_EDIT_MASTER_DIALOG_ERROR_MSG';
export const SWITCH_SHOW_MODE_EDIT_MASTER_DIALOG =
  'SWITCH_SHOW_MODE_EDIT_MASTER_DIALOG';
export const SHOW_UNAVAILABLE_TAGS = 'SHOW_UNAVAILABLE_TAGS';
export const HIDE_UNAVAILABLE_TAGS = 'HIDE_UNAVAILABLE_TAGS';

// アクティベーション
export const SUCCESS_API_ACTIVATE = 'SUCCESS_API_ACTIVATE';
export const ERROR_API_ACTIVATE = 'ERROR_API_ACTIVATE';

// 黒板
export const SUCCESS_API_GET_BLACKBOARD_PRESET_LIST =
  'SUCCESS_API_GET_BLACKBOARD_PRESET_LIST';
export const SUCCESS_API_CREATE_BLACKBOARD = 'SUCCESS_API_CREATE_BLACKBOARD';
export const SUCCESS_API_UPDATE_BLACKBOARD = 'SUCCESS_API_UPDATE_BLACKBOARD';
export const SUCCESS_API_DELETE_BLACKBOARD = 'SUCCESS_API_DELETE_BLACKBOARD';
export const SUCCESS_API_GET_BLACKBOARD_PRESET_FOR_REMOTE =
  'SUCCESS_API_GET_BLACKBOARD_PRESET_FOR_REMOTE';

// グループ管理
export const SUCCESS_API_GET_GROUPS = 'SUCCESS_API_GET_GROUPS';
export const SUCCESS_API_GROUP_PUT = 'SUCCESS_API_GROUP_PUT';
export const SUCCESS_API_GET_GROUP = 'SUCCESS_API_GET_GROUP';
export const GROUP_SUCCESS_API_GET_OPERATORS =
  'GROUP_SUCCESS_API_GET_OPERATORS';
export const SUCCESS_API_CREATE_GROUP = 'SUCCESS_API_CREATE_GROUP';
export const SUCCESS_API_UPDATE_GROUP = 'SUCCESS_API_UPDATE_GROUP';

// 企業選択
export const SUCCESS_API_GET_USER_COMPANIES = 'SUCCESS_API_GET_USER_COMPANIES';
export const SUCCESS_API_GET_USER_GROUPS = 'SUCCESS_API_GET_USER_GROUPS';
export const SUCCESS_API_GET_COMPANY_ACTIVATED =
  'SUCCESS_API_GET_COMPANY_ACTIVATED';

// お気に入り
export const SUCCESS_API_GET_FAVORITES = 'SUCCESS_API_GET_FAVORITES';
export const SUCCESS_API_CREATE_FAVORITE = 'SUCCESS_API_CREATE_FAVORITE';
export const SUCCESS_API_DELETE_FAVORITE = 'SUCCESS_API_DELETE_FAVORITE';
export const SUCCESS_API_UPDATE_FAVORITE = 'SUCCESS_API_UPDATE_FAVORITE';

// 報告書関係
export const SUCCESS_API_GET_REPORTS = 'SUCCESS_API_GET_REPORTS';
export const SUCCESS_API_GET_REPORT_DETAIL = 'SUCCESS_API_GET_REPORT_DETAIL';
export const SELECT_REPORTS_PAGE = 'SELECT_REPORTS_PAGE';
export const SET_REFRESH_PAGE_TRUE = 'SET_REFRESH_PAGE_TRUE';
export const SET_REFRESH_PAGE_FALSE = 'SET_REFRESH_PAGE_FALSE';
export const SELECT_REPORT = 'SELECT_REPORT';
export const OPEN_REPORT_EDIT_PAGE = 'OPEN_REPORT_EDIT_PAGE';
export const RESET_REPORT_DETAILS = 'RESET_REPORT_DETAILS';
export const UPDATE_REPORT_EDIT = 'UPDATE_REPORT_EDIT';
export const SUCCESS_API_GET_SELECTABLE_REPORT_MEDIA =
  'SUCCESS_API_GET_SELECTABLE_REPORT_MEDIA';
export const SUCCESS_API_GET_REPORT_PREVIEW = 'SUCCESS_API_GET_REPORT_PREVIEW';
export const FAILED_API_GET_REPORT_PREVIEW = 'FAILED_API_GET_REPORT_PREVIEW';
export const SUCCESS_API_CREATE_REPORT = 'SUCCESS_API_CREATE_REPORT';
export const SUCCESS_API_UPDATE_REPORT_STATUS =
  'SUCCESS_API_UPDATE_REPORT_STATUS';
